function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 .25a.75.75 0 000 1.5h8a.25.25 0 01.25.25v14a.25.25 0 01-.25.25H7a.75.75 0 000 1.5h8A1.75 1.75 0 0016.75 16V2A1.75 1.75 0 0015 .25H7zm2.03 4.22a.75.75 0 00-1.06 1.06l2.72 2.72H1.5a.75.75 0 000 1.5h9.19l-2.72 2.72a.75.75 0 101.06 1.06l4-4a.75.75 0 000-1.06l-4-4z",
  fill: "#B5BFCD"
});

var SvgExit = function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none"
  }, props), _ref);
};

export default SvgExit;